import { StImage } from './Logo.styled'

const Logo = () => <StImage src='/img/logo.png' alt='Logo van MijnZiekenhuis' />

export { Logo }
